/**
 * @fileoverview PATCH handler for the "/data_objects/:type_name/:object_id" endpoint
 */
import fetch from "@lib/fetch";

import { customObjectsTypeName } from "../customObjectsTypeName/constants";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameObjectId } from "./constants";
import type { PatchCustomObjectsTypeNameObjectIdProps, PatchCustomObjectsTypeNameObjectIdResult } from "./types";

export const patchCustomObjectsTypeNameObjectId = reactQueryMutationAdapter(
  [customObjectsTypeName, customObjectsTypeNameObjectId],
  ({
    typeName,
    objectId,
    attributes,
  }: PatchCustomObjectsTypeNameObjectIdProps): Promise<PatchCustomObjectsTypeNameObjectIdResult> => {
    return fetch(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(objectId)}`,
      "PATCH",
      { attributes },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
